<template>
    <div>
        <el-form-item label="Folder" required
                      :error="errors['folder']">
            <el-select filterable v-model="form.folder" placeholder="Wybierz folder">
                <el-option v-for="folder in folders"
                           :key="folder.id"
                           :label="folder.working_name"
                           :value="folder.id"/>
            </el-select>
        </el-form-item>
    </div>
</template>
<script>
    import {InstagramFolder} from '@/api'

    export default {
        props: ['form', 'errors'],
        data () {
            return {
                folders: []
            }
        },
        methods: {
            fetchData () {
                InstagramFolder.all().then(response => {
                    this.folders = response.data
                })
            }
        },
        mounted () {
            this.fetchData()
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// InstagramWidget.vue?22765707